import { render, staticRenderFns } from "./freezeTable.vue?vue&type=template&id=3825b140"
import script from "./freezeTable.vue?vue&type=script&lang=js"
export * from "./freezeTable.vue?vue&type=script&lang=js"
import style0 from "./freezeTable.vue?vue&type=style&index=0&id=3825b140&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports